import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import App from './app/App';
import * as Sentry from '@sentry/react';

const rootNode = document.getElementById('root');

if (!rootNode) {
  throw new Error('Root element not found');
}

Sentry.init({
  dsn: 'https://0171ce9748e889096888dde49c90a0b2@sentry.a88.ai/5',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api\.fcb\.tm/,
  ],
  environment: 'dev',
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(rootNode).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
